export default __webpack_public_path__ + "static/CuervoVP-greenScreenc-27933b56be67e93519740dc911d1e8d9.jpg";